import N8nDatatable from './Datatable.vue';

export default N8nDatatable;
